// extracted by mini-css-extract-plugin
export var resourcesArchiveItem = "resources-module--resources-archive-item--1af9f";
export var resourcesArchiveList = "resources-module--resources-archive-List--b5d74";
export var resourcesItem = "resources-module--resources-item--7b1d5";
export var resourcesItemContent = "resources-module--resources-item-content--84aaf";
export var resourcesItemImage = "resources-module--resources-item-image--e5ef2";
export var resourcesWrap = "resources-module--resources-wrap--c11fa";